import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Typography } from '@curves/ui-base';
import { PageLayout } from '@Local/Components/Layout';

import useProductApi from '@Apis/useProductApi';
import useOptions from '@Util/hook/useOptions';
import { ensureValidOptions } from '@Util/utils';
import { PRODUCT_DETAIL_ROUTER_URL, PRODUCT_OVERVIEW_ROUTER } from '@Router/routerPath';
import ProductForm from '@Local/Product/Form/ProductForm';

/**
 * 編輯商品頁（`/site/product/edit/:productID`）
 */
const ProductEditPage = () => {
    const { productID } = useParams();
    const history = useHistory();
    const { getProductDetailApi, putProductApi, getProductOptionsApi } = useProductApi();
    // 取得商品選項（新增／編輯的分類不含「全部」）
    const getOptionsApi = useCallback(() => getProductOptionsApi({ skipAll: true }), [getProductOptionsApi]);
    // 商品選項（分類樹、上下架選項）
    const { options } = useOptions({ getOptionsApi, isFetchOnMount: true });

    // 是否載入中
    const [isLoading, setIsLoading] = useState(true);
    // 要編輯的商品資料
    const [product, setProduct] = useState(null);

    // 載入要編輯的商品資料
    const fetchProduct = useCallback(async () => {
        setIsLoading(true);
        const resp = await getProductDetailApi(productID);
        setProduct(resp || null);
        setIsLoading(false);
    }, [getProductDetailApi, productID]);

    useEffect(() => {
        fetchProduct();
    }, [fetchProduct]);

    if (isLoading) {
        return (
            <PageLayout>
                <PageLayout.Header title="編輯商品" />
                <Typography variant="body1">載入中...</Typography>
            </PageLayout>
        );
    }

    if (!product) {
        return (
            <PageLayout>
                <PageLayout.Header title="編輯商品" />
                <Typography variant="body1">查無商品</Typography>
            </PageLayout>
        );
    }

    return (
        <PageLayout>
            <PageLayout.Header title="編輯商品" />

            <ProductForm
                productID={productID}
                categoryOptions={ensureValidOptions(options.categoryOptions)}
                initialProduct={product}
                submitApi={(payload) => putProductApi(productID, payload)}
                onSuccess={() => history.push(PRODUCT_DETAIL_ROUTER_URL(productID))}
                onCancel={() => history.push(PRODUCT_OVERVIEW_ROUTER)}
            />
        </PageLayout>
    );
};

export default ProductEditPage;
